var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-subscription"},[_c('i18n',{attrs:{"path":"application.no-subscriptions.text"}},[_c('a',{on:{"click":_vm.openWebsite}},[_vm._v(_vm._s(_vm.$t('application.no-subscriptions.link')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c7daa8f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Application/no-subscriptions.vue
// module id = MjvF
// module chunks = 1